import _ from './underscore.js';
import baseIteratee from './_baseIteratee.js';
// External wrapper for our callback generator. Users may customize
// `_.iteratee` if they want additional predicate/iteratee shorthand styles.
// This abstraction hides the internal-only `argCount` argument.
export default function iteratee(value, context) {
    return baseIteratee(value, context, Infinity);
}
_.iteratee = iteratee;
